/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A photo/video stored in a claim's media library.
 * @export
 * @interface ClaimPhoto
 */
export interface ClaimPhoto {
    /**
     * 
     * @type {number}
     * @memberof ClaimPhoto
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimPhoto
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimPhoto
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimPhoto
     */
    uploadedBy: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimPhoto
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPhoto
     */
    mimeType: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimPhoto
     */
    sizeBytes: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimPhoto
     */
    caption?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPhoto
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPhoto
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the ClaimPhoto interface.
 */
export function instanceOfClaimPhoto(value: object): value is ClaimPhoto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimPhotoFromJSON(json: any): ClaimPhoto {
    return ClaimPhotoFromJSONTyped(json, false);
}

export function ClaimPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'claimId': json['claimId'],
        'uploadedBy': json['uploadedBy'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'sizeBytes': json['sizeBytes'],
        'caption': json['caption'] == null ? undefined : json['caption'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimPhotoToJSON(json: any): ClaimPhoto {
    return ClaimPhotoToJSONTyped(json, false);
}

export function ClaimPhotoToJSONTyped(value?: Omit<ClaimPhoto, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'uploadedBy': value['uploadedBy'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
        'caption': value['caption'],
    };
}

